
import React from 'react'
import injectSheet from 'react-jss'
import { purgeState } from '../../../utils/localStorage'
import { TextButton } from '../../'

const BottomNavHome = (props) => {
  const {
    classes,
    history,
    home,
    steps,
    incomplete,
  } = props

  const handleClick = () => {
    if (incomplete > 0) {
      purgeState()
      window.location.reload()
    }
    history.push(steps[0].config.path)
  }

  return (
    <div className={`${classes.navContainer}`}>
      <div className={`${classes.textContainer}`}>
        <div>
          <p>{home.intro}</p>
        </div>
      </div>

      <div className={`${classes.buttonContainer}`}>
        <div>
          <TextButton
            index={101}
            handleClick={() => handleClick()}
            primary
            text={home.start}
          />
        </div>
      </div>
    </div>
  )
}

const styles = theme => ({
  navContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    fontSize: '60%',
    [theme.media.medium]: {
      fontSize: '100%',
    },
  },
  textContainer: {
    width: '60%',
    padding: `0 ${theme.sizes.gutter / 2}px`,
    color: theme.colors.main_3,
    [theme.media.medium]: {
      width: '50%',
    },
  },
  buttonContainer: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
})

export default injectSheet(styles)(BottomNavHome)



// WEBPACK FOOTER //
// ./src/modules/core/components/bottomNavHome.jsx